'use strict';

import {throttle} from '../../components/custom-lodash';

export const init = () => {
    let freezeScollEvent = false;
    $(window).scroll(
        throttle(() => {
            if (!freezeScollEvent) {
                if ($('#product-tabs-container').isInViewport(200)) {
                    $('.product-tab-nav').last().removeClass('hidden');
                    $('.product-tab-nav').first().addClass('hidden');
                } else {
                    $('.product-tab-nav').first().removeClass('hidden');
                    $('.product-tab-nav').last().addClass('hidden');
                }
            }
        }, 100)
    );
    $('.product-tab-nav').click(event => {
        var $btn = $(event.target);
        $('.product-tab-nav').toggleClass('hidden');
        freezeScollEvent = true;
        $('html, body').animate(
            {
                scrollTop:
                    $btn.attr('id') == 'show-description'
                        ? parseInt($('#product-tabs-container').offset().top) - 200
                        : 0
            },
            500,
            () => (freezeScollEvent = false)
        );
    });
};
